function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighskilsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    xmlns: "http://www.w3.org/2000/svg",
    height: 29,
    id: "screenshot-ead713f5-05d7-80ac-8007-ba5935f81d75",
    viewBox: "2231 1235 37 29",
    style: {
      WebkitPrintColorAdjust: ":exact"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d75",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "render-22951-Layer_2",
    viewBox: "0 0 52.68 41.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "render-22951-Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 2.05,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.34,
    cy: 7.44,
    r: 2.05,
    transform: "translate(13.05 31.36) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 7.44,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.56,
    cy: 12.83,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.34,
    cy: 12.83,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 12.83,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.19,
    cy: 12.83,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.56,
    cy: 18.22,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.41,
    cy: 18.22,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.34,
    cy: 18.22,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 18.22,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.19,
    cy: 18.22,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.56,
    cy: 23.6,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.48,
    cy: 23.6,
    r: 2.05,
    transform: "translate(9.02 57.81) rotate(-80.78)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.41,
    cy: 23.6,
    r: 2.05,
    transform: "translate(1.99 49.73) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.34,
    cy: 23.6,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 23.6,
    r: 2.05,
    transform: "translate(-6.28 39.83) rotate(-80.78)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.19,
    cy: 23.6,
    r: 2.05,
    transform: "translate(-12.04 32) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.56,
    cy: 28.99,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.48,
    cy: 28.99,
    r: 2.05,
    transform: "translate(3.7 62.34) rotate(-80.78)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.41,
    cy: 28.99,
    r: 2.05,
    transform: "translate(-3.25 53.88) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.34,
    cy: 28.99,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 28.99,
    r: 2.05,
    transform: "translate(-11.6 44.35) rotate(-80.78)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.19,
    cy: 28.99,
    r: 2.05,
    transform: "translate(-17.28 36.15) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.12,
    cy: 28.99,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.63,
    cy: 28.99,
    r: 2.05,
    transform: "translate(10.78 71.61) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.56,
    cy: 34.38,
    r: 2.05,
    transform: "translate(.86 69.85) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.48,
    cy: 34.38,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.41,
    cy: 34.38,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.34,
    cy: 34.38,
    r: 2.05,
    transform: "translate(-13.17 52.12) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 34.38,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.19,
    cy: 34.38,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.12,
    cy: 34.38,
    r: 2.05,
    transform: "translate(-27.21 34.39) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.05,
    cy: 34.38,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.63,
    cy: 34.38,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.56,
    cy: 39.77,
    r: 2.05,
    transform: "translate(-4.39 74) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.48,
    cy: 39.77,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.41,
    cy: 39.77,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.34,
    cy: 39.77,
    r: 2.05,
    transform: "translate(-18.42 56.27) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 39.77,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.19,
    cy: 39.77,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.12,
    cy: 39.77,
    r: 2.05,
    transform: "translate(-32.45 38.54) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.05,
    cy: 39.77,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.63,
    cy: 39.77,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "render-22951-Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 2.05,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.34,
    cy: 7.44,
    r: 2.05,
    transform: "translate(13.05 31.36) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 7.44,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.56,
    cy: 12.83,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.34,
    cy: 12.83,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 12.83,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.19,
    cy: 12.83,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.56,
    cy: 18.22,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.41,
    cy: 18.22,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.34,
    cy: 18.22,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 18.22,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.19,
    cy: 18.22,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.56,
    cy: 23.6,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.48,
    cy: 23.6,
    r: 2.05,
    transform: "translate(9.02 57.81) rotate(-80.78)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.41,
    cy: 23.6,
    r: 2.05,
    transform: "translate(1.99 49.73) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.34,
    cy: 23.6,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 23.6,
    r: 2.05,
    transform: "translate(-6.28 39.83) rotate(-80.78)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.19,
    cy: 23.6,
    r: 2.05,
    transform: "translate(-12.04 32) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.56,
    cy: 28.99,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.48,
    cy: 28.99,
    r: 2.05,
    transform: "translate(3.7 62.34) rotate(-80.78)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.41,
    cy: 28.99,
    r: 2.05,
    transform: "translate(-3.25 53.88) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.34,
    cy: 28.99,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 28.99,
    r: 2.05,
    transform: "translate(-11.6 44.35) rotate(-80.78)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.19,
    cy: 28.99,
    r: 2.05,
    transform: "translate(-17.28 36.15) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.12,
    cy: 28.99,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.63,
    cy: 28.99,
    r: 2.05,
    transform: "translate(10.78 71.61) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.56,
    cy: 34.38,
    r: 2.05,
    transform: "translate(.86 69.85) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.48,
    cy: 34.38,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.41,
    cy: 34.38,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.34,
    cy: 34.38,
    r: 2.05,
    transform: "translate(-13.17 52.12) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 34.38,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.19,
    cy: 34.38,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.12,
    cy: 34.38,
    r: 2.05,
    transform: "translate(-27.21 34.39) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.05,
    cy: 34.38,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.63,
    cy: 34.38,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.56,
    cy: 39.77,
    r: 2.05,
    transform: "translate(-4.39 74) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.48,
    cy: 39.77,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.41,
    cy: 39.77,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.34,
    cy: 39.77,
    r: 2.05,
    transform: "translate(-18.42 56.27) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 39.77,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.19,
    cy: 39.77,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.12,
    cy: 39.77,
    r: 2.05,
    transform: "translate(-32.45 38.54) rotate(-76.72)",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.05,
    cy: 39.77,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.63,
    cy: 39.77,
    r: 2.05,
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d76",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d76"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 2231,
    y: 1235,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    width: 36.71350724968852,
    height: 28.712470091794785,
    fill: "none",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d77"
  }, /*#__PURE__*/React.createElement("defs", {
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d78",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d79"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d79"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2245.126476688519,
    cy: 1236.4074740241076,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d7a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d7a"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2249.357875478303,
    cy: 1240.1035677049304,
    rx: 1.4086007964594955,
    ry: 1.4275657983798737,
    transform: "matrix(0.232984, -0.972481, 0.974017, 0.226477, 517.412283, 3146.705433)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d7b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d7b"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2245.126476688519,
    cy: 1240.108100848468,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d7c"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d7c"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2262.054553588575,
    cy: 1243.8087276728293,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d7d"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d7d"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2249.3567536248443,
    cy: 1243.8087276728293,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d7e"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d7e"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2245.126476688519,
    cy: 1243.8087276728293,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d7f"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d7f"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2240.8892305974387,
    cy: 1243.8087276728293,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d80"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d80"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2262.054553588575,
    cy: 1247.5093544971905,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d81"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d81"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2253.5870305611697,
    cy: 1247.5093544971905,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d82"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d82"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2249.3567536248443,
    cy: 1247.5093544971905,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d83"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d83"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2245.126476688519,
    cy: 1247.5093544971905,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d84"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d84"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2240.8892305974387,
    cy: 1247.5093544971905,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d85"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d85"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2262.054553588575,
    cy: 1251.2031155946042,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d86"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d86"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2257.817714731278,
    cy: 1251.2089337143025,
    rx: 1.4080223391595155,
    ry: 1.4281363397512905,
    transform: "matrix(0.162576, -0.986696, 0.987454, 0.157908, 655.239346, 3281.413249)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d87"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d87"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2253.582721445602,
    cy: 1251.2084904391372,
    rx: 1.4086007964594955,
    ry: 1.427565798379419,
    transform: "matrix(0.232984, -0.972481, 0.974017, 0.226477, 509.836430, 3159.403927)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d88"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d88"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2249.3567536248443,
    cy: 1251.2031155946042,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d89"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d89"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2245.1215100270647,
    cy: 1251.205318228549,
    rx: 1.4080223391597428,
    ry: 1.4281363397512905,
    transform: "matrix(0.162576, -0.986696, 0.987454, 0.157908, 644.610811, 3268.882910)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d8a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d8a"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2240.8881854448255,
    cy: 1251.2103998619236,
    rx: 1.4086007964594955,
    ry: 1.427565798379419,
    transform: "matrix(0.232984, -0.972481, 0.974017, 0.226477, 500.097657, 3147.060214)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d8b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d8b"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2262.054553588575,
    cy: 1254.9037424189655,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d8c"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d8c"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2257.81796794419,
    cy: 1254.9120437426036,
    rx: 1.4080223391597428,
    ry: 1.428136339750381,
    transform: "matrix(0.162576, -0.986696, 0.987454, 0.157908, 651.582908, 3284.531860)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d8d"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d8d"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2253.5868099944646,
    cy: 1254.9078381826967,
    rx: 1.4086007964594955,
    ry: 1.4275657983798737,
    transform: "matrix(0.232984, -0.972481, 0.974017, 0.226477, 506.236340, 3162.269433)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d8e"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d8e"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2249.3567536248443,
    cy: 1254.9037424189655,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d8f"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d8f"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2245.1217632399766,
    cy: 1254.9015625299035,
    rx: 1.4080223391595155,
    ry: 1.4281363397512905,
    transform: "matrix(0.162576, -0.986696, 0.987454, 0.157908, 640.961152, 3271.995739)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d90"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d90"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2240.892273993688,
    cy: 1254.9097476054844,
    rx: 1.408600796459723,
    ry: 1.427565798379419,
    transform: "matrix(0.232984, -0.972481, 0.974017, 0.226477, 496.497567, 3149.925721)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d91"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d91"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2236.6589536611136,
    cy: 1254.9037424189655,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d92"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d92"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2266.281345995241,
    cy: 1254.9059287599102,
    rx: 1.408600796459723,
    ry: 1.4275657983798737,
    transform: "matrix(0.232984, -0.972481, 0.974017, 0.226477, 515.975113, 3174.613146)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d93"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d93"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2262.0521331204845,
    cy: 1258.6036856006194,
    rx: 1.4086007964594955,
    ry: 1.4275657983798737,
    transform: "matrix(0.232984, -0.972481, 0.974017, 0.226477, 509.129563, 3173.360619)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d94"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d94"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2257.8173074974948,
    cy: 1258.604369243326,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d95"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d95"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2253.5870305611697,
    cy: 1258.604369243326,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d96"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d96"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2249.357597119708,
    cy: 1258.6055950234058,
    rx: 1.4086007964594955,
    ry: 1.4275657983798737,
    transform: "matrix(0.232984, -0.972481, 0.974017, 0.226477, 499.390790, 3161.016906)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d97"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d97"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2245.126476688519,
    cy: 1258.604369243326,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d98"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d98"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2240.8892305974387,
    cy: 1258.604369243326,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d99"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d99"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2236.656091964176,
    cy: 1258.6075044461923,
    rx: 1.4086007964594955,
    ry: 1.4275657983798737,
    transform: "matrix(0.232984, -0.972481, 0.974017, 0.226477, 489.646671, 3148.666416)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d9a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d9a"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2232.4286767247886,
    cy: 1258.604369243326,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d9b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d9b"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2266.2848305249,
    cy: 1258.604369243326,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d9c"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d9c"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2262.049252514591,
    cy: 1262.3030333441802,
    rx: 1.4086007964594955,
    ry: 1.4275657983798737,
    transform: "matrix(0.232984, -0.972481, 0.974017, 0.226477, 505.524127, 3176.219348)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d9d"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d9d"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2257.8173074974948,
    cy: 1262.3049960676872,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d9e"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d9e"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2253.5870305611697,
    cy: 1262.3049960676872,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81d9f"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81d9f"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2249.3547165138148,
    cy: 1262.3049427669666,
    rx: 1.408600796459723,
    ry: 1.4275657983798737,
    transform: "matrix(0.232984, -0.972481, 0.974017, 0.226477, 495.785355, 3163.875635)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81da0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81da0"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2245.126476688519,
    cy: 1262.3049960676872,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81da1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81da1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2240.8892305974387,
    cy: 1262.3049960676872,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81da2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81da2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2236.6601805130385,
    cy: 1262.3068521897526,
    rx: 1.408600796459723,
    ry: 1.427565798379419,
    transform: "matrix(0.232984, -0.972481, 0.974017, 0.226477, 486.046581, 3151.531922)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81da3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81da3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2232.4286767247886,
    cy: 1262.3049960676872,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81da4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81da4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2266.2848305249,
    cy: 1262.3049960676872,
    rx: 1.4286767247886019,
    ry: 1.4074740241076142,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighskilsIcon);
export default __webpack_public_path__ + "static/media/highskilsIcon.e6fbb738a585a9bbfbf7bed64675a187.svg";
export { ForwardRef as ReactComponent };